import Icon from '../components/Icon.vue'

Icon.register({
  'angle-double-up': {
    width: 320,
    height: 512,
    paths: [
      {
        d: 'M177 255.7L313 391.7C322.4 401.1 322.4 416.3 313 425.6L290.4 448.2C281 457.6 265.8 457.6 256.5 448.2L160 351.9 63.6 448.3C54.2 457.7 39 457.7 29.7 448.3L7 425.7C-2.4 416.3-2.4 401.1 7 391.8L143 255.8C152.4 246.3 167.6 246.3 177 255.7zM143 63.7L7 199.7C-2.4 209.1-2.4 224.3 7 233.6L29.6 256.2C39 265.6 54.2 265.6 63.5 256.2L159.9 159.8 256.3 256.2C265.7 265.6 280.9 265.6 290.2 256.2L312.8 233.6C322.2 224.2 322.2 209 312.8 199.7L176.8 63.7C167.6 54.3 152.4 54.3 143 63.7z'
      }
    ]
  }
})



//////////////////
// WEBPACK FOOTER
// ./~/vue-awesome/icons/angle-double-up.js
// module id = xjN/
// module chunks = 144